import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@repo/ui';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query-client';
import { captureTokenFromHash } from '@/lib/auth';
import { captureOpenerFromHash } from '@/lib/opener';
import { injectCaptionFonts } from '@/editor/fonts';
import App from '@/App';
import '@/index.css';

// Both read the handoff hash; the opener origin first, since capturing the
// token strips the hash.
captureOpenerFromHash();
// SSO: capture a token handed off from the streamer dashboard before first render.
captureTokenFromHash();
// Kick off caption webfont loading early so the preview has them by first paint.
injectCaptionFonts();

createRoot(document.getElementById('root')!).render(
  <ThemeProvider defaultTheme="dark">
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </ThemeProvider>
);
